/*
  Clamps a number to a min and max value. For example - with a min of 2 and a max of 4:
  - 5 becomes 4
  - 1 becomes 2
  */
export const clamp = (value: number, min = 0, max = 1) => Math.max(min, Math.min(max, value));
